Wee.fn.make('navigation', {
	init: function() {
		var priv = this.$private;

		priv.initScreen();
		priv.initEvents();
		priv.unstickHeader();
	}
}, {
	_construct: function() {
		this.$mobileMenu = $('ref:mobileMenu'),
		this.$desktopMenu = $('ref:desktopMenu'),
		this.$header = $('ref:header');
		this.$footer = $('ref:footer');
	},

	/**
	 * Init screen map
	 *
	 * @private
	 */
	initScreen: function() {
		var scope = this;

		$.screen.map([
			{
				max: 3,
				callback: function() {
					scope.initMobileNav();
					scope.closeMobileNav();
				}
			},
			{
				min: 4,
				callback: function() {
					scope.initDesktopNav();
				}
			}
		]);
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:menuToggle': {
				click: function() {
					scope.toggleMobileNav();
				}
			},
			'ref:mobileLink': {
				click: function() {
					scope.closeMobileNav();
				}
			},
			'window': {
				scroll: _.throttle(function() {
					scope.unstickHeader();
				}, 15)
			}
		});
	},

	/**
	 *	Toggle mobile nav
	 *
	 * @private
	 */
	toggleMobileNav: function() {
		this.$header.isActive() ? this.$header.deactivate() : this.$header.activate();
		this.$mobileMenu.isActive() ? this.$mobileMenu.deactivate() : this.$mobileMenu.activate();
	},

	/**
	 * Close mobile nav
	 *
	 * @private
	 */
	closeMobileNav: function() {
		this.$header.deactivate();
		this.$mobileMenu.deactivate();
		$('ref:main').css('paddingTop', $('ref:header').height() + 'px');
	},

	/**
	 * Init mobile nav
	 *
	 * @private
	 */
	initMobileNav: function() {
		$('ref:desktopMenu').remove();
		this.$mobileMenu.insertAfter('ref:headerMain');
	},

	/**
	 * Init desktop nav
	 *
	 * @private
	 */
	initDesktopNav: function() {
		$('ref:mobileMenu').remove();
		this.$header.deactivate();
		Wee.$insertAfter(this.$desktopMenu, $('ref:headerLogo'));
	},

	/**
	 * Remove fixed positioning from header
	 *
	 * @private
	 */
	unstickHeader: function() {
		var $header = this.$header,
			footerTop = parseInt(this.$footer.offset().top),
			headerBottom = parseInt(Wee.$scrollTop() + $header.height());

		if (footerTop <= headerBottom && $('ref:mobileMenu').isInactive()) {
			$header.addClass('-is-stuck')
				.css('top', footerTop - this.$header.height() + 'px');
		} else {
			$header.removeClass('-is-stuck')
				.css('top', '0px');
		}
	}
});